import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined'

const support = {
  id: 'support',
  type: 'group',
  children: [
    {
      id: 'contact-us',
      title: 'menu:contactUs',
      type: 'item',
      url: '/contact-us',
      icon: ContactSupportOutlinedIcon,
      breadcrumbs: false,
    },
  ],
}

export default support
